
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { validateEnvironment } from "./config/env";

// Validar variáveis de ambiente na inicialização
const envValid = validateEnvironment();

if (!envValid && import.meta.env.PROD) {
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
